import React, {useState} from "react";
import "./PeykCurrentCard.scss";
import {useHistory} from "react-router-dom";
import { ConvertTMonthName} from "../../../Services";
import moment from "moment-jalaali";
import {courier_orders_api, courierOrderAcceptOrder_api, courierOrderUpdate_api} from "../PeykService";

function PeykCurrentCard({item}) {

    const history = useHistory()
    const [acceptLadda , set_acceptLadda] = useState(false)

    const convertStack = (stack) =>{
        switch (stack) {
            case 'take':
                return "تحویل  شد"
                break;
            case 'notTake':
                return "تحویل گرفتم"
                break;
        }
    }

    const ConvertToJalaliSplited = (date) =>{
        if(date){
            let month = ConvertTMonthName(moment.utc(date.split('+')[0]).format('jMM'));
            let year = moment.utc(date.split('+')[0]).format('jYYYY');
            let day = moment.utc(date.split('+')[0]).format('jDD');
            let hh = moment.utc(date.split('+')[0]).format('HH');
            let mm = moment.utc(date.split('+')[0]).format('mm');
            return {day,month,year,hh,mm}
        }
    }

    const courierAccept = async ()=>{
        set_acceptLadda(true)
        try{
            if(item.status===20){
                const response = await courierOrderAcceptOrder_api(item.uid)
                set_acceptLadda(false)
                console.log("Response : ",response)
                history.push(`/peyk/${item.uid}`)
            }else {
                set_acceptLadda(false)
                history.push(`/peyk/${item.uid}`)
            }
        }catch (e) {
            console.log(e)
            set_acceptLadda(false)
        }
    }

     const convertStatusCode = (code) =>{
        let result =""
        switch (code) {
            case 1:
                result  =  "اولیه"
                break;
            case 2:
                result  =  "آماده پرداخت"
                break;
            case 3:
                result  =  "نهایی شده توسط مشتری"
                break;
            case 5:
                result  =  "رد شده توسط صندوقدار"
                break;
            case 13:
                result  =  "آماده ارسال"
                break;
            case 20:
                result  =  "قبول کردن"
                break;
            case 25:
                result  =  "تحویل شده"
                break;
            case 9:
                result  =  "شروع جمع آوری"
                break;
            case 10:
                result  =  "جمع آوری شده"
                break;
            case 15:
                result  =  "ادامه"
                break;
            case 30:
                result  =  "توسط مشتری کنسل شد"
                break;
        }

        return result;

    }


    return(
        <div className="current-card-container">
            <div
                onClick={()=>{
                    courierAccept()
                }}

                className={item.status===20?"current-card-btn-active":"current-card-btn-deActive"}>
                {!acceptLadda?
                    <span>{convertStatusCode(item.status)}</span>:
                    <i className="fa fa-spinner fa-spin"></i>
                }
            </div>
            <div className="history-card-info" onClick={()=>{
                // let pos = {lat:32.6539,lng:51.6660}
                if(item.address && item.address.coordinate){
                    history.push("/map",{position:item.address.coordinate})
                }

            }}>
                <div className="current-card-info">
                    <span className="name">{item.uid}</span>
                    <div className="status" style={{display:'flex'}}>
                        <span>{ConvertToJalaliSplited(item.created).hh+":"+ConvertToJalaliSplited(item.created).mm+" - "}</span>
                        <span>{ConvertToJalaliSplited(item.created).year}</span>
                    <span>{ConvertToJalaliSplited(item.created).month}</span>
                    <span>{ConvertToJalaliSplited(item.created).day}</span>
                    </div>
                </div>
                <img src="/svg/green_marker.svg" alt="" style={{width:25}}/>
            </div>
        </div>
    )

}

export {PeykCurrentCard}

